module.exports = __webpack_public_path__ + "img/14-1GT.ac55ffb.jpeg";